var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-img video-box"},[_c('video',{staticClass:"video-background",attrs:{"poster":_vm.bgImg,"src":_vm.bg,"loop":"","playsinline":"","muted":"muted","autoplay":"autoplay"},domProps:{"muted":true}}),_c('div',{staticClass:"layer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }